export enum CustomPricingType {
    Flat = "Flat",
    ThreeTier = "3Tier",
    ICPlus = "IC+"
  }
